import $ from 'jquery';
import magnificPopup from 'magnific-popup';

$(function () {

    // Product page gallery popups
    $('.js-product-swiper').magnificPopup({
        type: 'image',
        delegate: 'a',
        removalDelay: 160,
        mainClass: 'mfp-fade',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
    })

    // Video popups
    $('.js-video-popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    // Gallery row popups
    $('.gallery-row').magnificPopup({
        type: 'image',
        delegate: 'a',
        removalDelay: 160,
        mainClass: 'mfp-fade',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
    });

});